import { render } from "./ProductSpecialPriceList.vue?vue&type=template&id=af0f2e7c&scoped=true"
import script from "./ProductSpecialPriceList.vue?vue&type=script&lang=js"
export * from "./ProductSpecialPriceList.vue?vue&type=script&lang=js"

import "./ProductSpecialPriceList.vue?vue&type=style&index=0&id=af0f2e7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af0f2e7c"

export default script